import { DOCUMENT, Service, inject } from "@angular/core";
import { CourseBrand } from "@sdk/lib/types/course";

const MINDLIFE_ICONS = { ico: "favicon.ico", png: "assets/img/favicon-32.png" };
const HEART_ICONS = { ico: "assets/img/favicon-heart.ico", png: "assets/img/favicon-heart-32.png" };

@Service()
export class BrandFaviconService {
  private readonly _document = inject(DOCUMENT);

  apply(courseBrand: CourseBrand | null | undefined): void {
    const icons = courseBrand === "uplift" || courseBrand === "uplift_now" ? HEART_ICONS : MINDLIFE_ICONS;
    this._document.querySelectorAll<HTMLLinkElement>('link[rel="icon"]').forEach((link) => {
      const href = link.type === "image/png" ? icons.png : icons.ico;
      if (link.getAttribute("href") !== href) {
        link.setAttribute("href", href);
      }
    });
  }
}
